import { AppComponent } from './app.component';

// Angular
import { BrowserModule } from '@angular/platform-browser';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  provideAppInitializer,
  LOCALE_ID,
  InjectionToken,
} from '@angular/core';

import { MessageService } from 'primeng/api';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

//lib
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { AuthGuard, CONFIGURATION } from '@acpgruppe/essp-ui';
import { AuthConfigService } from '@acpgruppe/essp-ui';
import { AppTrackerService } from '@acpgruppe/essp-ui';

import { environment } from '../environments/environment';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TokenInterceptorService } from './shared/services/token-interceptor.service';
import { appConfig } from 'src/environments/app-config';

import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { EsspThemeConfiguration } from '@acpgruppe/essp-ui';

export const BASE_PATH = new InjectionToken<string>('basePath');
registerLocaleData(localeDe);

@NgModule({
  declarations: [AppComponent],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ToastModule,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthGuard,
    AuthConfigService,
    PermissionGuard,
    provideAppInitializer(() => {
      inject(AppTrackerService);
    }),

    provideAppInitializer(() => {
      const initializerFn = (
        (initialAuthService: AuthConfigService) => () =>
          initialAuthService.initAuth(environment)
      )(inject(AuthConfigService));
      return initializerFn();
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: EsspThemeConfiguration,
      translation: {
        accept: 'Bestätigen',
        reject: 'Abbrechen',
        //translations
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: BASE_PATH, useValue: environment.salesNavBackendUrl },
    { provide: CONFIGURATION, useValue: appConfig },
    { provide: LOCALE_ID, useValue: 'de' },
    provideHttpClient(withInterceptorsFromDi()),
    MessageService,
  ],
})
export class AppModule {}
